import { CommonModule, Location } from "@angular/common";
import { Component, effect, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import {
  CreditCardDirectivesModule,
  CreditCardValidators,
} from "angular-cc-library";

import { GlobalService } from "../../../../shared/services/global.service";
import { SettingService } from "../../../../shared/services/setting.service";

import { NgbModal, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { LaddaModule } from "angular2-ladda";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { NgxTrimDirectiveModule } from "ngx-trim-directive";
import { SharedModule } from "primeng/api";
import { CalendarModule } from "primeng/calendar";
import { DisplayDescriptionComponent } from "src/app/shared/components/display-description/display-description.component";
import swal from "sweetalert2";
import {
  AGE_AND_WEIGHT_PATTERN,
  API_URLS,
  DATEFORMATE,
  FILE_PATH,
  MOMENT_FORMAT_START_DATE,
  MOMENT_FORMAT_START_YEAR,
  P_CALENDAR_DATE_FORMAT,
  SELECT_SEX,
} from "../../../../config/app.constants";
import { OutPostModalService } from "../../../../shared/header/outpost-list-modal/out-post-modal.service";
import { OutpostListModalComponent } from "../../../../shared/header/outpost-list-modal/outpost-list-modal.component";
import { HttpinterceptorService } from "../../../../shared/services/httpinterceptor.service";
import { Utils } from "../../../../shared/utils";
import { ModalVaccinationProductComponent } from "../../grooming/modal-vaccination-product/modal-vaccination-product.component";
import { StarRatingComponent } from "../../star-rating/star-rating.component";

declare var $: any;

@Component({
  selector: "app-cage-detail",
  templateUrl: "./cage_booking.component.html",
  styleUrls: ["./cage_booking.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    StarRatingComponent,
    RouterLink,
    FormsModule,
    CalendarModule,
    SharedModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgxTrimDirectiveModule,
    NgbTooltip,
    CreditCardDirectivesModule,
    LaddaModule,
  ],
})
export class CageBookingComponent implements OnInit {
  cageTypeId: any;
  petTypeId: any;
  cageTypeGrid: any;
  checkinDate: any;
  checkoutDate: any;
  updatedAmount: any;
  totalDays: any;
  savedBookingId: any;
  createdNewCageTypeId: any = "";
  createdNewPetId: any = "";
  saveBookingInformation: any;
  filterRanges: object;
  inwardDate: Date;
  outwardDate: Date;
  inwardTime: any;
  outwardTime: any;

  inwardHour: any;
  outwardHour: any;

  userPets = [];
  selectedUserPet = [];
  displayExtraPrice = [];
  pets_array = [];
  cardList = [];
  myAddons = [];
  otherCages = [];

  selectedCageTypeId: string;
  defaultSubPetId: string;
  errorMessageInWardTime: string;
  errorMessageOutWardTime: string;
  card: string;
  errorMessage: string = "";
  newAddedPet: string = "";

  petAddLimit: number = 0;
  addedPetsCount: number = 0;

  allowedNextStep: boolean = true;
  readyPage: boolean = false;
  payment = false;
  isSecondStep: boolean = false;
  petInstructionPart: boolean = false;
  newPetSubmitted: boolean = false;
  is_advance_booking_amount = false;
  addNewCard: boolean = true;
  minimumPaymentFlag: boolean = false;
  maximumPaymentFlag: boolean = false;
  moveToDivFlag: boolean = true;
  submittedNewCard: boolean = false;

  currentPet;
  filePath = FILE_PATH;
  format = DATEFORMATE;
  select_sex = SELECT_SEX;

  newPetDetails: FormGroup;
  name = new FormControl("", [Validators.required]);
  sub_pet_type_id = new FormControl("", []);
  sex = new FormControl("", []);
  color = new FormControl("", []);
  age = new FormControl("", []);
  weight = new FormControl("", []);
  breed = new FormControl("", []);
  microchip = new FormControl("", []);
  description = new FormControl("", []);
  feeding_instruction = new FormControl("", {});
  pet_likes = new FormControl("", {});
  pet_dis_likes = new FormControl("", {});
  pet_schedule_complete_day = new FormControl("", {});
  care_instruction = new FormControl("", {});
  allergies = new FormControl("", {});

  petDetails: FormGroup;
  pets = new FormControl("", {});

  addCardFormData = {
    cc_exp_month: "",
    cc_exp_year: "",
    cc_csc: "",
    cc_number: "",
    cc_holder_name: "",
  };
  addCreditCardForm = new FormGroup({
    cc_holder_name: new FormControl("", [Validators.required]),
    card_number: new FormControl("", [
      Validators.required,
      CreditCardValidators.validateCCNumber,
    ]),
    card_expiry: new FormControl("", [
      Validators.required,
      CreditCardValidators.validateExpDate,
    ]),
    card_cvv: new FormControl("", [Validators.minLength(3)]),
    save: new FormControl("", {}),
  });

  // for select box
  pet_type: any[] = [];
  petSubTypeList = [];
  bookingDetails: any = [];
  selectedOutpostId;
  currentBoardService;
  apiParams = {};
  showOutpostModal: boolean = false;
  selectedOutpost: any = "";

  selectedCageData;
  selectedType: any;
  vacconationApiParams;
  savedBookingData;
  petProductDetail;

  isMandatoryProducts = false;
  mandatoryProductList = [];
  selectedAddonDetail: any;
  selectedPetId: any;
  checkAddonList = [];
  formatDates: any[];
  selectedDates: any[] = [];
  selectedPetIndex;
  selectedOptionValue: any;
  previousSelectedOptionValue: any;
  previousSelectedDates: any;
  selectedAddonIndex: any;
  tempSelectedDate: any = [];
  isPetAvailable: boolean = false;
  clinicTiming: any;
  days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  outwardMinute: any;
  inwardMinute: any;
  minInWardDate: Date;
  maxDate: Date;
  pCalendarDateFormat: string = P_CALENDAR_DATE_FORMAT;
  selectedDateArray = [];

  constructor(
    private http: HttpinterceptorService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private globalService: GlobalService,
    private settingService: SettingService,
    private location: Location,
    private outpostModalService: OutPostModalService,
    public modalService: NgbModal,
    private toasterService: ToastrService
  ) {
    const minTime = new Date();
    minTime.setHours(6);
    minTime.setMinutes(0);
    const MaxTime = new Date();
    MaxTime.setHours(20);
    MaxTime.setMinutes(0);
    this.inwardTime = minTime;
    this.outwardTime = MaxTime;
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }

    let today = new Date();
    today.setDate(today.getDate() + 25);
    this.maxDate = today;

    effect(() => {
      const el = this.outpostModalService.currentBoardService();
      if (el) {
        if (localStorage.getItem("selectedOutpostId")) {
          this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
        }
        this.getCageTypeDetails(true);
        if (this.isSecondStep) {
          this.getBookingPrice(false);
        }
      }
    });
  }

  ngOnInit() {
    this.minInWardDate = new Date();
    this.minInWardDate.setDate(this.minInWardDate.getDate() + 1); // Tomorrow Date
    this.minInWardDate.setHours(0, 0, 0, 0); // Set time to start of the day

    localStorage.removeItem("purchasedProduct");

    this.route.params.subscribe((params) => {
      this.initNewPetForm();
      this.initializePetValidation();
      this.getBoardingAddons();
      this.cageTypeId = params["cageTypeId"];
      this.selectedCageTypeId = this.decodeString(this.cageTypeId);
      this.petTypeId = params["petTypeId"];
      this.savedBookingId = params["saveBookingId"];
      this.getCageTypeDetails(true);
      this.getPets();
      this.getPetExtraPrice();
      this.addedPetsCount = 0;
      this.petAddLimit = 0;
      if (this.savedBookingId) {
        this.getCageTypeDetails(true);
        this.GetSaveBookingInfo();
      } else {
        this.saveBookingInformation = {
          pet: { addons: [] },
        };
      }
      this.getCurrentPetType();
    });

    // this.currentBoardService =
    //   this.outpostModalService.currentBoardService.subscribe((el: any) => {
    //     if (el) {
    //       if (localStorage.getItem("selectedOutpostId")) {
    //         this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    //       }
    //       this.getCageTypeDetails(true);
    //       if (this.isSecondStep) {
    //         this.getBookingPrice(false);
    //       }
    //     }
    //   });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    localStorage.removeItem("purchasedProduct");
  }

  selectPetFromPetDetail() {
    this.getCageTypeDetails(true);
    const selectedPet = JSON.parse(sessionStorage.getItem("bookingPet"));
    const selectPetForBooking = [selectedPet.id];
    this.selectedUserPet = selectPetForBooking;
    this.onSelectPet(selectedPet);
    if (sessionStorage.getItem("bookingPet")) {
      sessionStorage.removeItem("bookingPet");
    }
  }

  GetSaveBookingInfo() {
    this.http
      .post(API_URLS.GET_SAVED_BOOKING_DETAILS + this.savedBookingId, {}, false)
      .subscribe((res) => {
        if (res.data) {
          this.saveBookingInformation = res.data;
          this.fillSaveBookingInfo();
        }
      });
  }

  fillSaveBookingInfo() {
    this.selectedCageTypeId = this.saveBookingInformation.cage_type_id;
    if (this.saveBookingInformation.is_past) {
      this.errorMessage =
        "Sorry! Check-In Date and Check-Out Date are out-dated.";
    } else {
      if (!this.saveBookingInformation.cage_available) {
        this.allowedNextStep = false;
        this.errorMessage =
          "Sorry! there are no cage available base on selected date.";
      } else {
        this.allowedNextStep = true;
      }
      const inTimeArray = this.saveBookingInformation.inward_time.split(":");
      const outTimeArray = this.saveBookingInformation.outward_time.split(":");
      const minTime = new Date();
      minTime.setHours(inTimeArray[0]);
      minTime.setMinutes(inTimeArray[1]);
      const maxTime = new Date();
      maxTime.setHours(outTimeArray[0]);
      maxTime.setMinutes(outTimeArray[1]);
      this.inwardTime = minTime;
      this.outwardTime = maxTime;
      this.inwardDate = new Date(this.saveBookingInformation.booking_from);
      this.outwardDate = new Date(this.saveBookingInformation.booking_to);
      const inward_date = Utils.getDateFormat(this.inwardDate);
      const outward_date = Utils.getDateFormat(this.outwardDate);
      const checkinDate =
        inward_date[0] + "/" + inward_date[1] + "/" + inward_date[2];
      const checkoutdate =
        outward_date[0] + "/" + outward_date[1] + "/" + outward_date[2];
      const checkinDiff = moment(
        new Date(checkinDate),
        MOMENT_FORMAT_START_DATE
      );
      const checkoutDiff = moment(
        new Date(checkoutdate),
        MOMENT_FORMAT_START_DATE
      );
      this.totalDays = checkoutDiff.diff(checkinDiff, "days");
      this.checkinDate =
        inward_date[2] + "/" + inward_date[1] + "/" + inward_date[0];
      this.checkoutDate =
        outward_date[2] + "/" + outward_date[1] + "/" + outward_date[0];
      this.updatedAmount = this.saveBookingInformation.paid_amount;
      this.onChange();
    }
    if (this.saveBookingInformation.pets) {
      this.saveBookingInformation.pets = JSON.parse(
        this.saveBookingInformation.pets
      );
    }
    const bindPetArray = [];
    this.is_advance_booking_amount =
      this.saveBookingInformation.is_advance_booking_amount == 1 ? true : false;
    this.pets_array = this.saveBookingInformation.pets;
    this.saveBookingPatchValue();
    this.onChange();
    for (const pet in this.saveBookingInformation.pets) {
      bindPetArray.push(this.saveBookingInformation.pets[pet].id);
    }
    this.selectedUserPet = bindPetArray;
  }

  saveBookingPatchValue() {
    this.addedPetsCount = this.pets_array.length;
    const control = <FormArray>this.petDetails.controls["pets"];
    const selectedPetArray = [];
    const bindPetArray = [];
    for (const key in this.pets_array) {
      if (this.pets_array.hasOwnProperty(key)) {
        if (!this.pets_array[key]["sub_pet_type_id"]) {
          this.pets_array[key]["sub_pet_type_id"] = this.defaultSubPetId;
        }
        if (
          typeof this.pets_array[key].pet_detail === "string" &&
          this.pets_array[key].pet_detail != null
        ) {
          this.pets_array[key].pet_detail = JSON.parse(
            this.pets_array[key].pet_detail
          );
        }
        const selectedPets = $.grep(this.pet_type, (val, inx) => {
          return val.id == this.pets_array[key].id;
        });
        if (selectedPets.length > 0) {
          selectedPetArray.push({
            id: this.pets_array[key].id,
            item_text: this.pets_array[key].name,
          });
          bindPetArray.push(this.pets_array[key].id);
        }
        control.push(this.initPets());
      }
    }
    this.selectedUserPet = bindPetArray;
    this.petDetails.patchValue({ pets: this.pets_array });
  }

  initializePetValidation() {
    this.petDetails = this.formBuilder.group({
      pets: this.formBuilder.array([]),
    });
  }

  initNewPetForm() {
    this.newPetDetails = this.formBuilder.group({
      name: this.name,
      sub_pet_type_id: this.sub_pet_type_id,
      sex: this.sex,
      color: this.color,
      age: this.age,
      weight: this.weight,
      breed: this.breed,
      microchip: this.microchip,
      description: this.description,
      pet_detail: this.formBuilder.group({
        feeding_instruction: this.feeding_instruction,
        pet_likes: this.pet_likes,
        pet_dis_likes: this.pet_dis_likes,
        pet_schedule_complete_day: this.pet_schedule_complete_day,
        care_instruction: this.care_instruction,
        allergies: this.allergies,
      }),
      addonList: [[], []],
      addons: [[], []],
    });
  }

  initPets() {
    return this.formBuilder.group({
      id: [""],
      name: ["", [Validators.required]],
      pet_type_id: [""],
      sub_pet_type_id: [""],
      description: [""],
      age: ["", [Validators.pattern(AGE_AND_WEIGHT_PATTERN)]],
      color: [""],
      sex: [""],
      subPetType: [""],
      weight: ["", [Validators.pattern(AGE_AND_WEIGHT_PATTERN)]],
      breed: [""],
      microchip: [""],
      pet_detail: this.formBuilder.group({
        feeding_instruction: ["", []],
        pet_likes: ["", []],
        pet_dis_likes: ["", []],
        pet_schedule_complete_day: ["", []],
        care_instruction: ["", []],
        allergies: ["", []],
      }),
      addonList: [[], []],
      addons: [[], []],
    });
  }

  openNewPetModal() {
    if (this.petAddLimit > this.addedPetsCount) {
      this.initNewPetForm();
      $(".new-pet-modal").modal("toggle");
      Utils.disableBodyScroll();
    } else {
      this.exceedCageError();
    }
  }

  moveToDiv(index) {
    if (!this.moveToDivFlag) {
      $("html, body").animate(
        {
          scrollTop: $("#added_pet_" + index).offset().top - 160,
        },
        1000
      );
      this.moveToDivFlag = true;
    }
  }

  getCageTypeDetails(flag) {
    if (flag) {
      this.inwardDate = null;
      this.outwardDate = null;
      if (this.petDetails.value.name) {
        this.petDetails.reset();
      }
    }
    this.http
      .post(
        API_URLS.GET_CAGE_TYPE_DETAILS,
        {
          cage_type_id: this.selectedCageTypeId,
          out_post_id: this.selectedOutpostId,
        },
        false
      )
      .subscribe((res) => {
        if (res.data) {
          this.petAddLimit = res.data.allow_pet_number;
          if (res.data.size) {
            const data = res.data.size.split(",");
            res.data["width"] = data[0];
            res.data["height"] = data[1];
            res.data["length"] = data[2];
            res.data["unit"] = data[3];
          }
          this.cageTypeGrid = res.data;

          if (
            this.cageTypeGrid.outpost_images &&
            this.cageTypeGrid.outpost_images.cover_images
          ) {
            this.cageTypeGrid["default_cover_image"] =
              this.cageTypeGrid.outpost_images.cover_images;
          } else {
            this.cageTypeGrid["default_cover_image"] =
              this.cageTypeGrid.cover_image;
          }

          this.readyPage = true;
          if (flag) {
            this.setSession();
          }
        }
      });
  }

  calculateMinimumAmount(minimumAmount) {
    if (parseFloat(minimumAmount) == 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
      return false;
    } else if (
      parseFloat(minimumAmount) > 0 &&
      minimumAmount <= this.bookingDetails["total"]
    ) {
      this.maximumPaymentFlag = false;
      this.minimumPaymentFlag = false;
      return false;
    } else if (parseFloat(minimumAmount) < 0) {
      this.minimumPaymentFlag = true;
      this.maximumPaymentFlag = false;
    } else {
      this.maximumPaymentFlag = true;
      this.minimumPaymentFlag = false;
      return false;
    }
  }

  getCurrentPetType() {
    this.globalService.getPetTypes().subscribe((data) => {
      const petTypeList = data;
      this.currentPet =
        petTypeList[
          petTypeList.indexOf(
            petTypeList.find(({ id, name }) => {
              return name == this.petTypeId;
            })
          )
        ];
    });
  }

  getPets() {
    if (this.petTypeId) {
      this.http
        .post(API_URLS.GET_USER_PETS, { pet_type_id: this.petTypeId }, false)
        .subscribe((res) => {
          if (res.type === "success") {
            this.pet_type = [];
            if (res.data) {
              res.data = res.data.filter((pet) => pet?.is_active);
              for (const index in res.data) {
                if (res.data.hasOwnProperty(index)) {
                  if (
                    typeof res.data[index].pet_detail === "string" &&
                    res.data[index].pet_detail !== null &&
                    res.data[index].pet_detail
                  ) {
                    res.data[index]["pet_detail"] = JSON.parse(
                      res.data[index].pet_detail
                    );
                  } else {
                    res.data[index]["pet_detail"] = {};
                  }
                  this.pet_type.push({
                    id: res.data[index].id,
                    item_text: res.data[index].name,
                  });
                }
              }
              this.userPets = res.data;
            }
            if (sessionStorage.getItem("bookingPet")) {
              this.selectPetFromPetDetail();
            }
          }
        });
    }
  }

  getPetExtraPrice() {
    this.http
      .post(
        API_URLS.PET_EXTRA_PRICE,
        { cage_type_id: this.selectedCageTypeId, pet_type_id: this.petTypeId },
        false
      )
      .subscribe((response) => {
        if (response.code == "200") {
          this.petSubTypeList = [];
          this.displayExtraPrice = [];
          if (response.data.length > 0) {
            if (response.data[0].sub_pet_type_id !== null) {
              this.petSubTypeList = response.data;
            }
            this.displayExtraPrice = response.data;
          }
          const defaultPet = $.grep(this.petSubTypeList, function (val, inx) {
            return val.is_default == 1;
          });
          if (defaultPet.length && defaultPet[0].sub_pet_type_id) {
            this.defaultSubPetId = defaultPet[0].sub_pet_type_id;
          } else {
            this.defaultSubPetId = "";
          }
        }
      });
  }

  onPetInstruction() {
    this.newPetSubmitted = true;
    if (this.newPetDetails.valid) {
      this.petInstructionPart = true;
    } else {
      this.newPetDetails.markAllAsTouched();
      this.scrollToFirstInvalidControl();
      return false;
    }
  }

  scrollToFirstInvalidControl() {
    let form = document.getElementById("add-new-pet-form"); // <-- your formID
    let firstInvalidControl = form.getElementsByClassName("ng-invalid")[0];
    firstInvalidControl.scrollIntoView();
    (firstInvalidControl as HTMLElement).focus();
  }

  checkAddedPetLimit(event) {
    if (this.petAddLimit > this.addedPetsCount) {
      this.onSelectPet(event);
    } else {
      this.exceedCageError();
      this.selectedUserPet = $.grep(this.selectedUserPet, function (val, inx) {
        return val != event.id;
      });
    }
  }

  onSelectPet(event) {
    if (event.id) {
      const petDetails_res = this.userPets.filter(function (data) {
        return data.id == event.id;
      });
      const control = <FormArray>this.petDetails.controls["pets"];
      for (const iterator of petDetails_res) {
        control.push(this.initPets());
      }
      petDetails_res[0]["pet_type_id"] = this.petTypeId;
      if (!petDetails_res[0]["sub_pet_type_id"]) {
        petDetails_res[0]["sub_pet_type_id"] = this.defaultSubPetId;
      }
      this.pets_array = [];
      for (let index in this.petDetails.value.pets) {
        if (parseInt(index) !== this.petDetails.value.pets.length - 1) {
          this.pets_array.push(this.petDetails.value.pets[index]);
        }
      }
      this.pets_array.push({
        ...petDetails_res[0],
        addonList: Object.assign([], this.myAddons),
      });
      this.petDetails.patchValue({ pets: this.pets_array });
      this.addedPetsCount += 1;
      this.moveToDivFlag = true;

      const addons = this.petDetails.controls["pets"].value.flatMap(
        (item) => item.addons
      );

      const addonsIds = addons.map((addon) => {
        return addon.id;
      });

      const petControl = <FormArray>this.petDetails.controls["pets"];

      if (addonsIds && !addonsIds.length) {
        for (let i = 0; i < petControl.controls.length; i++) {
          let addonControl = <FormControl>(
            petControl.controls[i].get("addonList")
          );
          let addonList = JSON.parse(
            JSON.stringify(petControl.controls[i].value.addonList)
          );

          for (const addon in addonList) {
            if (this.checkAddonList.includes(addonList[addon].id)) {
              addonList[addon].showPrice = addonList[addon].price;
            }
          }
          addonControl.setValue(addonList);
        }
        this.checkAddonList = [];
      } else {
        if (this.checkAddonList && this.checkAddonList.length) {
          for (let i = 0; i < petControl.controls.length; i++) {
            let addonControl = <FormControl>(
              petControl.controls[i].get("addonList")
            );
            let addonList = JSON.parse(
              JSON.stringify(petControl.controls[i].value.addonList)
            );
            if (i > 0) {
              addonList.some((addon) => {
                if (this.checkAddonList.includes(addon.id)) {
                  addon.showPrice = addon.pet_extra_price;
                }
              });
            }
            addonControl.setValue(addonList);
          }
        }
      }
      this.addonPriceCalculation();
    }
  }

  onRemovePet(event) {
    const control = <FormArray>this.petDetails.controls["pets"];
    for (let index = 0; index < control.controls.length; index++) {
      if (event?.id == control.controls[index].value.id) {
        control.removeAt(index);
        this.pets_array.splice(index, 1);
      }
    }
    const petControl = <FormArray>this.petDetails.controls["pets"];
    const addons = this.petDetails.controls["pets"].value.flatMap(
      (item) => item.addons
    );

    if (addons && !addons.length) {
      for (let i = 0; i < petControl.controls.length; i++) {
        let addonControl = <FormControl>petControl.controls[i].get("addonList");
        let addonList = JSON.parse(
          JSON.stringify(petControl.controls[i].value.addonList)
        );

        for (const addon in addonList) {
          if (this.checkAddonList.includes(addonList[addon].id)) {
            addonList[addon].showPrice = addonList[addon].price;
          }
        }
        addonControl.setValue(addonList);
      }
      this.checkAddonList = [];
    } else {
      if (petControl.value && petControl.value.length) {
        const control = <FormGroup>(
          this.petDetails.controls["pets"]["controls"][0]
        );
        let addonControl = <FormControl>control.get("addonList");
        let addonList = JSON.parse(JSON.stringify(control.value.addonList));
        let addonArray = JSON.parse(JSON.stringify(control.value.addons));

        for (const addon in addonList) {
          if (this.checkAddonList.includes(addonList[addon].id)) {
            addonList[addon].showPrice = addonList[addon].price;

            for (let i = 0; i < addonArray.length; i++) {
              if (addonArray[i].id == addonList[addon].id) {
                addonList[addon].addonCheckoutPrice =
                  addonList[addon].showPrice *
                  addonArray[i].selected_dates.length;
              }
            }
          }
        }
        addonControl.setValue(addonList);
      } else {
        this.checkAddonList = [];
      }
    }

    this.addedPetsCount -= 1;
  }

  cancelSelection(id, petIndex) {
    this.selectedUserPet = $.grep(this.selectedUserPet, function (val, inx) {
      return val != id;
    });
    const petControl = <FormArray>this.petDetails.controls["pets"];
    for (let index = 0; index < petControl.controls.length; index++) {
      if (id == petControl.controls[index].value.id) {
        this.pets_array.splice(index, 1);
        petControl.removeAt(index);
      }
    }

    const addons = this.petDetails.controls["pets"].value.flatMap(
      (item) => item.addons
    );

    if (addons && !addons.length) {
      for (let i = 0; i < petControl.controls.length; i++) {
        let addonControl = <FormControl>petControl.controls[i].get("addonList");
        let addonList = JSON.parse(
          JSON.stringify(petControl.controls[i].value.addonList)
        );

        for (const addon in addonList) {
          if (this.checkAddonList.includes(addonList[addon].id)) {
            addonList[addon].showPrice = addonList[addon].price;
          }
        }
        addonControl.setValue(addonList);
      }
      this.checkAddonList = [];
    } else {
      if (petControl.value && petControl.value.length) {
        const control = <FormGroup>(
          this.petDetails.controls["pets"]["controls"][0]
        );
        let addonControl = <FormControl>control.get("addonList");
        let addonList = JSON.parse(JSON.stringify(control.value.addonList));
        let addonArray = JSON.parse(JSON.stringify(control.value.addons));

        for (const addon in addonList) {
          if (this.checkAddonList.includes(addonList[addon].id)) {
            addonList[addon].showPrice = addonList[addon].price;

            for (let i = 0; i < addonArray.length; i++) {
              if (addonArray[i].id == addonList[addon].id) {
                addonList[addon].addonCheckoutPrice =
                  addonList[addon].showPrice *
                  addonArray[i].selected_dates.length;
              }
            }
          }
        }
        addonControl.setValue(addonList);
      } else {
        this.checkAddonList = [];
      }
    }
    this.addonPriceCalculation();
    this.addedPetsCount -= 1;
  }

  onSecondStep(savedBooking) {
    this.getProductList();
    this.savedBookingData = savedBooking;
  }

  getProductList() {
    this.vacconationApiParams = {
      petId: this.pets_array.map((el) => el.id),
      petTypeId: this.petTypeId,
    };

    this.http
      .post(
        API_URLS.MANDATORY_PRODUCTS_LIST,
        {
          pet_ids: this.pets_array.map((el) => el.id),
          pet_type_id: this.petTypeId,
        },
        false
      )
      .subscribe({
        next: (response) => {
          if (
            response.code === 200 &&
            response.type === "success" &&
            response.data
          ) {
            for (const data in response.data) {
              if (Object.prototype.hasOwnProperty.call(response.data, data)) {
                response.data[data]["mandatory_products"] = response.data[
                  data
                ].mandatory_products.filter(
                  (product) => product.status_to_given
                );
              }
            }
            for (const data in response.data) {
              if (response.data.hasOwnProperty(data)) {
                response.data[data]["selectedProduct"] = [];

                for (const product in response.data[data].mandatory_products) {
                  if (
                    Object.prototype.hasOwnProperty.call(
                      response.data[data].mandatory_products,
                      product
                    )
                  ) {
                    response.data[data].mandatory_products[product][
                      "description"
                    ] = Utils.htmlToPlaintext(
                      response.data[data].mandatory_products[product]
                        .description
                    );
                  }
                  response.data[data]["selectedProduct"].push(
                    response.data[data].mandatory_products[product]["id"]
                  );
                }
              }
            }

            this.mandatoryProductList = response.data.filter(
              (data) => data.mandatory_products.length
            );

            this.isMandatoryProducts = this.mandatoryProductList.some(
              (data) => {
                if (data.mandatory_products.length > 0) {
                  return true;
                } else {
                  return false;
                }
              }
            );
            if (this.isMandatoryProducts) {
              this.vacconationApiParams["mandatoryProductList"] =
                this.mandatoryProductList;
              this.openVaccinationModal();
            } else {
              this.formDataWithAPI();
            }
          } else {
            return false;
          }
        },
        error: () => {
          return false;
        },
      });
  }

  getBookingPrice(saveBookingFlag) {
    const pets = [];
    for (let index = 0; index < this.petDetails.value.pets.length; index++) {
      const pet = {
        id: this.petDetails.value.pets[index].id,
        name: this.petDetails.value.pets[index].name,
        pet_type_id: this.petTypeId,
        sub_pet_type_id: !this.petDetails.value.pets[index].sub_pet_type_id
          ? this.defaultSubPetId
          : this.petDetails.value.pets[index].sub_pet_type_id,
        addons:
          this.petDetails.value.pets[index].addons !== null
            ? this.petDetails.value.pets[index].addons
            : [],
      };
      pets.push(pet);
    }
    for (const productDetail in this.petProductDetail) {
      if (
        Object.prototype.hasOwnProperty.call(
          this.petProductDetail,
          productDetail
        )
      ) {
        for (const pet in pets) {
          if (Object.prototype.hasOwnProperty.call(pets, pet)) {
            if (pets[pet].id === this.petProductDetail[productDetail].pet_id) {
              pets[pet]["product_ids"] =
                this.petProductDetail[productDetail].product_ids.toString(",");
            }
          }
        }
      }
    }

    this.http
      .post(
        API_URLS.BOOKING_PRICE,
        {
          cage_type_id: this.selectedCageTypeId,
          booking_from: this.checkinDate,
          booking_to: this.checkoutDate,
          pet_type_id: this.petTypeId,
          out_post_id: this.selectedOutpostId,
          pets: pets,
        },
        false
      )
      .subscribe((response) => {
        if (response.type === "success" && response.code === 200) {
          if (response.data) {
            this.bookingDetails = response.data;
            this.updatedAmount = response.data.total;

            let dateWisePrice = [];

            for (const pet of this.bookingDetails.pets) {
              for (const petAddon of pet.addon) {
                dateWisePrice = [];
                petAddon.selected_dates = petAddon.selected_dates.sort(
                  (a: any, b) => {
                    return +new Date(a.date) - +new Date(b.date);
                  }
                );

                if (petAddon.selected_dates && petAddon.selected_dates.length) {
                  for (const date of petAddon.selected_dates) {
                    if (!dateWisePrice.includes(date.price)) {
                      dateWisePrice.push(date.price);
                    }
                  }
                  petAddon["dateWisePrice"] = JSON.parse(
                    JSON.stringify(dateWisePrice)
                  );
                }
              }
            }

            if (saveBookingFlag) {
              this.saveBookingInfo();
            } else {
              this.isSecondStep = true;
            }
          }
        } else {
          this.toasterService.error(response.message);
        }
      });
  }

  getBoardingAddons() {
    this.http.post(API_URLS.GET_BOARDING_ADDONS, {}, false).subscribe((res) => {
      this.myAddons = [];
      if (res.data) {
        this.myAddons = res.data;
        for (let i = 0; i < this.myAddons.length; i++) {
          this.myAddons[i]["showPrice"] = (
            " " + this.myAddons[i]["price"]
          ).slice(1);
          if (this.myAddons[i].options) {
            this.myAddons[i].options = JSON.parse(this.myAddons[i].options);

            this.myAddons[i].options = this.myAddons[i].options.map((value) => {
              return {
                value: value,
                isChecked: false,
              };
            });
          }
        }
      }
    });
  }

  onSelectAddon(optionModal, id, value, petId, addonInd, pet_i) {
    this.selectedAddonDetail = value;
    this.selectedPetIndex = pet_i;
    this.selectedAddonIndex = addonInd;

    let addonCheckboxElement = document.getElementById(
      `addonheckbox${pet_i}_${addonInd}`
    ) as HTMLInputElement;
    if (addonCheckboxElement) {
      addonCheckboxElement.checked = !addonCheckboxElement.checked; // Set to true or false based on your requirement
    }

    const checkinDiff = moment(
      new Date(this.checkinDate),
      MOMENT_FORMAT_START_YEAR
    );
    const checkoutDiff = moment(
      new Date(this.checkoutDate),
      MOMENT_FORMAT_START_YEAR
    );
    this.totalDays = checkoutDiff.diff(checkinDiff, "days");

    const control = <FormGroup>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex]
    );

    let addonList = JSON.parse(JSON.stringify(control.value.addonList));
    let addons = JSON.parse(JSON.stringify(control.value.addons));

    let addonListControl = <FormControl>control.get("addonList");
    let addonControl = <FormControl>control.get("addons");

    if (
      addonCheckboxElement.checked &&
      ((value.options && value.options.length) ||
        this.selectedAddonDetail.type == "custom")
    ) {
      addonCheckboxElement.checked = false;
      this.selectOptionModal(optionModal, value, petId, pet_i, addonInd);
    } else if (!addonCheckboxElement.checked) {
      const index = addons.findIndex((addonId) => addonId.id === id);
      if (index !== -1) {
        addons.splice(index, 1);
      }

      for (let i = 0; i < addonList.length; i++) {
        if (addonList[i].id == this.selectedAddonDetail.id) {
          addonList[i].addonCheckoutPrice = 0;
        }
      }

      addonListControl.setValue(addonList);
      addonControl.setValue(addons);
      this.checkAddonOption(id, value, petId, addonInd, pet_i);
      this.addonPriceCalculation();
    }
    if (
      this.selectedAddonDetail.type !== "custom" &&
      addonCheckboxElement.checked
    ) {
      let addonObj = {
        id: this.selectedAddonDetail.id,
        selected_dates: [],
        selected_option: "",
        type: this.selectedAddonDetail.type,
      };
      addons.push(addonObj);
      addonControl.setValue(addons);
      this.checkAddonOption(id, value, petId, addonInd, pet_i);
      this.addonPriceCalculation();
    }
  }

  saveBookingInfo() {
    if (this.petDetails.value.pets.length > 0) {
      for (const index in this.petDetails.value.pets) {
        if (this.petDetails.value.pets.hasOwnProperty(index)) {
          if (
            this.petDetails.value.pets[index].pet_detail &&
            typeof this.petDetails.value.pets[index].pet_detail === "object"
          ) {
            this.petDetails.value.pets[index]["pet_detail"] = JSON.stringify(
              this.petDetails.value.pets[index].pet_detail
            );
          }
          this.petDetails.value.pets[index]["sub_pet_type_id"] = !this
            .petDetails.value.pets[index].sub_pet_type_id
            ? this.defaultSubPetId
            : this.petDetails.value.pets[index].sub_pet_type_id;
        }
      }
    }
    const event = new Date(this.inwardTime);
    const inwardTime = event.toLocaleTimeString("it-IT");
    const event2 = new Date(this.outwardTime);
    const outwardTime = event2.toLocaleTimeString("it-IT");
    if (this.petDetails.value.pet_dropdown == 1) {
      this.petDetails.value.pet_dropdown = null;
    }
    const checkin_date = Utils.getDateFormat(this.inwardDate);
    this.checkinDate =
      checkin_date[2] + "/" + checkin_date[1] + "/" + checkin_date[0];
    const checkout_date = Utils.getDateFormat(this.outwardDate);
    this.checkoutDate =
      checkout_date[2] + "/" + checkout_date[1] + "/" + checkout_date[0];
    this.http
      .post(
        API_URLS.SAVE_BOOKING_DETAILS,
        {
          saved_booking_id: this.savedBookingId ? this.savedBookingId : "",
          cage_type_id: this.cageTypeGrid.id,
          is_advance_booking_amount: this.is_advance_booking_amount,
          cage_booking_id:
            this.createdNewCageTypeId != "" ? this.createdNewCageTypeId : "",
          booking_from: this.checkinDate,
          booking_to: this.checkoutDate,
          inward_time: inwardTime,
          outward_time: outwardTime,
          paid_amount: this.updatedAmount,
          pet_type_id: this.petTypeId,
          pets: this.petDetails.value.pets,
          out_post_id: this.selectedOutpostId,
        },
        true
      )
      .subscribe((response) => {
        if (response.type === "success" && response.code === 200) {
          if (response.data) {
            this.savedBookingId = response.data.id;
            this.router.navigate(["saved_bookings"]);
          }
        }
      });
  }

  getCard() {
    this.http.post(API_URLS.GET_CARD, {}, false).subscribe(
      (res) => {
        if (res.code == "200" && res.type === "success") {
          this.cardList = res.data;
          if (res.data.length === 1 || res.data.length > 1) {
            this.card = this.cardList[0].id;
          } else if (res.data.length === 0) {
            this.card = "1";
            this.changeCard(this.card);
          } else {
            this.card = "1";
          }
        }
      },
      (error) => {
        return false;
      }
    );
  }

  changeCard(cardId) {
    if (cardId != "1" && cardId != "") {
      this.cancelNewCard();
    } else if (cardId == "1") {
      this.addCardForm();
    }
  }

  addCardForm() {
    this.addNewCard = false;
  }

  cancelNewCard() {
    if (this.cardList.length === 1) {
      this.addNewCard = true;
      this.card = this.cardList[0].id;
    } else if (this.cardList.length > 1) {
      this.addNewCard = true;
    }
  }

  onChange() {
    this.is_advance_booking_amount = !this.is_advance_booking_amount;
  }

  selectInwardTime() {
    const d = new Date(this.inwardTime);
    const hour = d.getHours();
    const minute = d.getMinutes();

    if (hour < this.inwardHour) {
      const defualtTime = new Date();
      defualtTime.setHours(this.inwardHour);
      defualtTime.setMinutes(0);
      this.inwardTime = defualtTime;
      this.errorMessageInWardTime = `Please select drop-off time after ${this.inwardHour}:00 AM!`;
      return false;
    } else {
      this.errorMessageInWardTime = "";
      return true;
    }
  }

  selectOutwardTime() {
    const d = new Date(this.outwardTime);
    const hour = d.getHours();
    const minute = d.getMinutes();

    if (
      hour > this.outwardHour ||
      `${hour}:${minute}` > `${this.outwardHour}:${this.outwardMinute}`
    ) {
      const defualtTime = new Date();
      defualtTime.setHours(this.outwardHour);
      defualtTime.setMinutes(0);
      this.outwardTime = defualtTime;
      this.errorMessageOutWardTime = `Please select pick-up time before ${
        this.outwardHour - 12
      }:00 PM!`;
      return false;
    } else {
      this.errorMessageOutWardTime = "";
      return true;
    }
  }

  setSession() {
    if (sessionStorage.filterRanges) {
      this.filterRanges = JSON.parse(sessionStorage.filterRanges);
      if (this.filterRanges["fromDate"]) {
        this.inwardDate = new Date(this.filterRanges["fromDate"]);
        const inwardDate = Utils.getDateFormat(this.inwardDate);
        this.checkinDate =
          inwardDate[2] + "/" + inwardDate[1] + "/" + inwardDate[0];
      }
      if (this.filterRanges["toDate"]) {
        this.outwardDate = new Date(this.filterRanges["toDate"]);
        const outwardDate = Utils.getDateFormat(this.outwardDate);
        this.checkoutDate =
          outwardDate[2] + "/" + outwardDate[1] + "/" + outwardDate[0];
      }
      const checkinDiff = moment(
        new Date(this.checkinDate),
        MOMENT_FORMAT_START_YEAR
      );
      const checkoutDiff = moment(
        new Date(this.checkoutDate),
        MOMENT_FORMAT_START_YEAR
      );
      this.totalDays = checkoutDiff.diff(checkinDiff, "days");
      this.getDatesInRange();
      this.getClinicTiming();
    }
  }

  saveNewPet() {
    if (
      this.newPetDetails.value.pet_detail &&
      typeof this.newPetDetails.value.pet_detail === "object"
    ) {
      this.newPetDetails.value["pet_detail"] = JSON.stringify(
        this.newPetDetails.value.pet_detail
      );
    }
    this.newPetDetails.value["sub_pet_type_id"] = !this.newPetDetails.value
      .sub_pet_type_id
      ? this.defaultSubPetId
      : this.newPetDetails.value.sub_pet_type_id;
    this.newPetDetails.value["pet_type_id"] = this.petTypeId;
    if (this.newPetDetails.valid) {
      this.http
        .post(API_URLS.ADD_PET_FOR_BOOKING, this.newPetDetails.value, true)
        .subscribe((response) => {
          if (response.type === "success" && response.code === 200) {
            if (response.data) {
              this.newAddedPet = response.data.id;
              this.petInstructionPart = false;
              this.newPetDetails.reset();
              if (
                typeof response.data.pet_detail === "string" &&
                response.data.pet_detail !== null &&
                response.data.pet_detail
              ) {
                response.data["pet_detail"] = JSON.parse(
                  response.data.pet_detail
                );
              } else {
                response.data["pet_detail"] = {};
              }
              this.getPets();
              this.userPets.push(response.data);
              $(".new-pet-modal").modal("toggle");
              this.closeModal();
              this.onSelectPet(response.data);
              let bindPetArray = [];
              for (let index in this.selectedUserPet) {
                if (this.selectedUserPet.hasOwnProperty(index)) {
                  bindPetArray.push(this.selectedUserPet[index]);
                }
              }
              bindPetArray.push(this.newAddedPet);
              this.selectedUserPet = bindPetArray;
              this.moveToDivFlag = false;
            }
          }
        });
    } else {
      return false;
    }
  }

  exceedCageError() {
    swal
      .fire({
        title: "Exceed Cage Limit?",
        text: "You cannot select more pet than cage limit. Do you want to change cage?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, change it!",
        cancelButtonText: "No, keep it",
      })
      .then((result) => {
        if (result.value) {
          this.openOtherCageModel();
        }
      });
  }

  openOtherCageModel() {
    const otherCageApiData = {};
    otherCageApiData["pet_type_id"] = this.petTypeId;
    otherCageApiData["no_of_pet"] = this.petAddLimit + 1;
    otherCageApiData["out_post_id"] = this.selectedOutpostId;
    if (this.inwardDate !== null && this.outwardDate !== null) {
      const checkin_date = Utils.getDateFormat(this.inwardDate);
      const checkout_date = Utils.getDateFormat(this.outwardDate);
      otherCageApiData["inward_date"] =
        checkin_date[1] + "/" + checkin_date[0] + "/" + checkin_date[2];
      otherCageApiData["outward_date"] =
        checkout_date[1] + "/" + checkout_date[0] + "/" + checkout_date[2];
    }
    this.http.post(API_URLS.GET_CAGE_TYPE, otherCageApiData, false).subscribe(
      (response) => {
        if (response.code == "200") {
          this.otherCages = [];
          if (response.data) {
            for (const key in response.data) {
              if (response.data.hasOwnProperty(key)) {
                response.data[key].size = response.data[key].size.split(",");
              }
            }
            this.otherCages = response.data;

            this.otherCages.sort(
              (a, b) => b.is_available_for_outpost - a.is_available_for_outpost
            );

            for (const cage in this.otherCages) {
              if (Object.prototype.hasOwnProperty.call(this.otherCages, cage)) {
                if (
                  this.otherCages[cage].outpost_images &&
                  this.otherCages[cage].outpost_images.cover_images
                ) {
                  this.otherCages[cage]["default_cover_image"] =
                    this.otherCages[cage].outpost_images.cover_images;
                } else {
                  this.otherCages[cage]["default_cover_image"] =
                    this.otherCages[cage].cover_image;
                }
              }
            }
          }
        }
      },
      (error) => {
        this.router.navigate(["/"]);
      }
    );
    $(".select-another-cage-modal").modal("toggle");
    Utils.disableBodyScroll();
  }

  selectOtherCage(cageData) {
    if (cageData.is_available_for_outpost) {
      $(".select-another-cage-modal").modal("toggle");
    }
    this.cageTypeId = cageData.id;
    this.selectedCageTypeId = cageData.id;
    this.getPetExtraPrice();
    this.getCageTypeDetails(false);
    if (this.savedBookingId) {
      this.location.go(
        "/cage_booking/" +
          this.petTypeId +
          "/" +
          cageData.id +
          "/" +
          this.savedBookingId
      );
    } else {
      this.location.go("/cage_booking/" + this.petTypeId + "/" + cageData.id);
    }
  }

  bookingApply() {
    this.submittedNewCard = true;
    if (this.petDetails.value.pets.length > 0) {
      for (const index in this.petDetails.value.pets) {
        if (this.petDetails.value.pets.hasOwnProperty(index)) {
          if (
            this.petDetails.value.pets[index].pet_detail &&
            typeof this.petDetails.value.pets[index].pet_detail === "object"
          ) {
            this.petDetails.value.pets[index]["pet_detail"] = JSON.stringify(
              this.petDetails.value.pets[index].pet_detail
            );
          }
          this.petDetails.value.pets[index]["sub_pet_type_id"] = !this
            .petDetails.value.pets[index].sub_pet_type_id
            ? this.defaultSubPetId
            : this.petDetails.value.pets[index].sub_pet_type_id;
        }
      }
    }
    const event = new Date(this.inwardTime);
    const inwardTime = event.toLocaleTimeString("it-IT");
    const event2 = new Date(this.outwardTime);
    const outwardTime = event2.toLocaleTimeString("it-IT");
    if (this.petDetails.value.pet_dropdown == 1) {
      this.petDetails.value.pet_dropdown = null;
    }
    if (this.is_advance_booking_amount) {
      if (this.card == "1") {
        if (this.addCreditCardForm.valid) {
          const month = this.addCreditCardForm.value.card_expiry.split("/");
          this.addCardFormData.cc_exp_month = $.trim(month[0]);
          this.addCardFormData.cc_exp_year = $.trim(month[1]);
        } else {
          return false;
        }
      }
      this.payment = true;

      for (const productDetail in this.petProductDetail) {
        if (
          Object.prototype.hasOwnProperty.call(
            this.petProductDetail,
            productDetail
          )
        ) {
          for (const pet in this.petDetails.value.pets) {
            if (
              Object.prototype.hasOwnProperty.call(
                this.petDetails.value.pets,
                pet
              )
            ) {
              if (
                this.petDetails.value.pets[pet].id ===
                this.petProductDetail[productDetail].pet_id
              ) {
                this.petDetails.value.pets[pet]["product_ids"] =
                  this.petProductDetail[productDetail].product_ids.toString(
                    ","
                  );
              }
            }
          }
        }
      }

      this.http
        .post(
          API_URLS.BOOK_CAGE,
          {
            saved_booking_id: this.savedBookingId ? this.savedBookingId : null,
            cage_type_id: this.cageTypeGrid.id,
            is_advance_booking_amount: this.is_advance_booking_amount,
            cage_booking_id:
              this.createdNewCageTypeId != "" ? this.createdNewCageTypeId : "",
            booking_from: this.checkinDate,
            booking_to: this.checkoutDate,
            inward_time: inwardTime,
            outward_time: outwardTime,
            paid_amount: this.is_advance_booking_amount
              ? this.updatedAmount
              : 0,
            pet_type_id: this.petTypeId,
            pets: this.petDetails.value.pets,
            out_post_id: this.selectedOutpostId,
            card_detail: {
              cc_holder_name: this.addCreditCardForm.value.cc_holder_name,
              cc_number: this.addCreditCardForm.value.card_number.replace(
                /\s/g,
                ""
              ),
              cc_exp_month: this.addCardFormData.cc_exp_month,
              cc_csc: this.addCreditCardForm.value.card_cvv,
              cc_exp_year: this.addCardFormData.cc_exp_year,
              save: this.addCreditCardForm.value.save,
              id: this.card != "1" ? this.card : "",
            },
          },
          true
        )
        .subscribe(
          (res) => {
            if (res.type === "success") {
              this.payment = false;
              if (res.data && res.data.booking_id) {
                this.router.navigate(["booking/detail/", res.data.booking_id]);
              }
            } else {
              if (res.data) {
                if (res.data.cage_booking_id) {
                  this.createdNewCageTypeId = res.data.cage_booking_id;
                }
                if (res.data.pet_id) {
                  this.createdNewPetId = res.data.pet_id;
                }
              }
              this.payment = false;
            }
          },
          (error) => {
            this.payment = false;
          }
        );
    } else {
      this.payment = true;

      for (const productDetail in this.petProductDetail) {
        if (
          Object.prototype.hasOwnProperty.call(
            this.petProductDetail,
            productDetail
          )
        ) {
          for (const pet in this.petDetails.value.pets) {
            if (
              Object.prototype.hasOwnProperty.call(
                this.petDetails.value.pets,
                pet
              )
            ) {
              if (
                this.petDetails.value.pets[pet].id ===
                this.petProductDetail[productDetail].pet_id
              ) {
                this.petDetails.value.pets[pet]["product_ids"] =
                  this.petProductDetail[productDetail].product_ids.toString(
                    ","
                  );
              }
            }
          }
        }
      }

      this.http
        .post(
          API_URLS.BOOK_CAGE,
          {
            saved_booking_id: this.savedBookingId ? this.savedBookingId : null,
            cage_type_id: this.cageTypeGrid.id,
            is_advance_booking_amount: this.is_advance_booking_amount,
            cage_booking_id:
              this.createdNewCageTypeId != "" ? this.createdNewCageTypeId : "",
            booking_from: this.checkinDate,
            booking_to: this.checkoutDate,
            inward_time: inwardTime,
            outward_time: outwardTime,
            paid_amount: this.is_advance_booking_amount
              ? this.updatedAmount
              : 0,
            pet_type_id: this.petTypeId,
            pets: this.petDetails.value.pets,
            out_post_id: this.selectedOutpostId,
          },
          true
        )
        .subscribe(
          (res) => {
            if (res.type === "success") {
              this.payment = false;
              if (res.data && res.data.booking_id) {
                this.router.navigate(["booking/detail/", res.data.booking_id]);
              }
            } else {
              if (res.data) {
                if (res.data.cage_booking_id) {
                  this.createdNewCageTypeId = res.data.cage_booking_id;
                }
                if (res.data.pet_id) {
                  this.createdNewPetId = res.data.pet_id;
                }
              }
              this.payment = false;
            }
          },
          (error) => {
            this.payment = false;
          }
        );
    }
  }
  onSelect(cageData, type) {
    this.selectedCageData = cageData;
    this.selectedType = type;
    if (localStorage.getItem("selectedOutpostId")) {
      this.selectedOutpostId = localStorage.getItem("selectedOutpostId");
    }
    this.apiParams = {
      service_id: cageData.id,
      service_type: "boarding",
    };
    const modalRef = this.modalService.open(OutpostListModalComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-bg-blue",
    });
    modalRef.componentInstance.fromParent = { data: this.apiParams };
    modalRef.componentInstance.closeOutpostModal.subscribe((response) => {
      if (response) {
        this.selectedOutpost = response.title;
        this.selectedOutpostId = response.id;
        this.getCageTypeDetails(true);
        if (this.selectedType === "other_cage") {
          this.openOtherCageModel();
          this.selectOtherCage(this.selectedCageData);
        }
        this.storeOutpostIdInLocalStorage();
        setTimeout(() => {
          Utils.enableBodyScroll();
        }, 500);
      }
    });
  }
  storeOutpostIdInLocalStorage() {
    if (localStorage.getItem("selectedOutpostId")) {
      localStorage.removeItem("selectedOutpostId");
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    } else {
      localStorage.setItem("selectedOutpostId", this.selectedOutpostId);
    }
  }
  boardingRequestModal() {
    $(".boarding-request-modal").modal("toggle");
  }

  formDataWithAPI() {
    const inTime = this.selectInwardTime();
    const outTime = this.selectOutwardTime();
    if (inTime && outTime) {
      if (this.petDetails.valid) {
        if (this.savedBookingData) {
          this.getBookingPrice(true);
        } else {
          const inwardDate = this.inwardDate
            ? Utils.getDateFormat(this.inwardDate)
            : undefined;
          const outwardDate = this.outwardDate
            ? Utils.getDateFormat(this.outwardDate)
            : undefined;
          this.checkinDate = inwardDate
            ? inwardDate[1] + "/" + inwardDate[0] + "/" + inwardDate[2]
            : undefined;
          this.checkoutDate = outwardDate
            ? outwardDate[1] + "/" + outwardDate[0] + "/" + outwardDate[2]
            : undefined;
          const checkinDiff = moment(
            new Date(this.checkinDate),
            MOMENT_FORMAT_START_DATE
          );
          const checkoutDiff = moment(
            new Date(this.checkoutDate),
            MOMENT_FORMAT_START_DATE
          );
          this.totalDays = checkoutDiff.diff(checkinDiff, "days");

          this.getBookingPrice(false);
          this.getCard();
          this.settingService.checkValidAmount();
        }
      } else {
        return false;
      }
    }
  }

  // Open popup when click on edit icon
  selectOptionModal(optionModal, addon, petID, i, addonIndex, from?: any) {
    this.getDatesInRange();

    const checkinDiff = moment(
      new Date(this.checkinDate),
      MOMENT_FORMAT_START_YEAR
    );
    const checkoutDiff = moment(
      new Date(this.checkoutDate),
      MOMENT_FORMAT_START_YEAR
    );
    this.totalDays = checkoutDiff.diff(checkinDiff, "days");

    this.modalService.open(optionModal, {
      size: "lg",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-bg-blue",
    });
    this.selectedAddonDetail = addon;
    this.selectedPetId = petID;
    this.selectedPetIndex = i;
    this.selectedAddonIndex = addonIndex;

    const petId =
      this.petDetails.controls["pets"]["controls"][i]["controls"].id.value;
    let control = <FormControl>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex][
        "controls"
      ]["addons"]
    );

    if (
      this.selectedAddonDetail.options &&
      this.selectedAddonDetail.options.length
    ) {
      this.previousSelectedOptionValue = this.selectedAddonDetail.options.find(
        (option) => option.isChecked
      );
    }

    let hasCheckedTrue;
    if (this.selectedAddonDetail.options !== null) {
      hasCheckedTrue = this.selectedAddonDetail.options.some(
        (option) => option.isChecked
      );
    }
    if (this.selectedAddonDetail.options !== null && !hasCheckedTrue) {
      this.selectedAddonDetail.options[0].isChecked = true;
    }

    const isAddonIncluded = control.value.some(
      (item) => item.id === this.selectedAddonDetail.id
    );

    if (!isAddonIncluded) {
      this.formatDates.map((date) => {
        date.isChecked = true;
      });
    }

    for (const key in control.value) {
      // For option selection
      if (
        this.selectedAddonDetail &&
        this.selectedAddonDetail.options &&
        this.selectedAddonDetail.options.length
      ) {
        if (
          control.value[key].id == addon.id &&
          petId == this.selectedPetId &&
          control.value[key]["selected_option"] == ""
        ) {
          this.selectedAddonDetail.options.map((option) => {
            option.isChecked = false;
          });
          control.value[key]["selected_option"] =
            this.selectedAddonDetail.options[0].value;
          this.selectedAddonDetail.options[0].isChecked = true;
        } else if (
          control.value[key].id == addon.id &&
          petId == this.selectedPetId &&
          control.value[key]["selected_option"]
        ) {
          this.selectedAddonDetail.options.map((option) => {
            option.isChecked = false;
            if (option.value == control.value[key]["selected_option"]) {
              option.isChecked = true;
            }
          });
        }
      }
      // For Date selection
      if (this.formatDates && this.formatDates.length) {
        if (
          control.value[key].id == addon.id &&
          petId == this.selectedPetId &&
          !control.value[key]["selected_dates"].length
        ) {
          if (addon.type !== "single") {
            this.formatDates.map((date) => {
              date.isChecked = true;
              control.value[key]["selected_dates"].push(date.date);
              control.value[key]["type"] = addon.type;
            });
          } else {
            control.value[key]["selected_dates"] = [];
            control.value[key]["type"] = addon.type;
          }
        } else if (
          control.value[key].id == addon.id &&
          petId == this.selectedPetId &&
          control.value[key]["selected_dates"]
        ) {
          this.previousSelectedDates = control.value[key]["selected_dates"];

          this.formatDates.map((date) => {
            date.isChecked = false;
            if (control.value[key]["selected_dates"].includes(date.date)) {
              date.isChecked = true;
            }
          });
          this.totalDays = control.value[key]["selected_dates"].length;
        }
      }
    }
  }
  // Change addon option
  changeOption(event, ind) {
    this.selectedOptionValue = event.target.value;
    for (let i = 0; i < this.selectedAddonDetail.options.length; i++) {
      this.selectedAddonDetail.options[i].isChecked = false;
      if (i == ind) {
        this.selectedAddonDetail.options[i].isChecked = true;
      }
    }

    const control = <FormArray>this.petDetails.controls["pets"];
    if (control.controls.length > 0) {
      for (const index in control.controls) {
        if (control.controls.hasOwnProperty(index)) {
          if (control.controls[index].value.id == this.selectedPetId) {
            if (event.target.checked) {
              for (const addon of control.controls[index].value["addons"]) {
                if (addon.id == this.selectedAddonDetail.id) {
                  addon["selected_option"] = event.target.value;
                }
              }
            }
          }
        }
      }
    }
  }

  // Every addon click this function is check that checked addon is present OR not in array
  checkAddonOption(addonId, addonValue, petId, addonInd, pet_i) {
    if (!this.checkAddonList.includes(addonId)) {
      this.checkAddonList.push(addonId);
      for (let i = 0; i < this.petDetails.controls["pets"].value.length; i++) {
        if (this.petDetails.controls["pets"].value[i].id != petId) {
          const control = <FormGroup>(
            this.petDetails.controls["pets"]["controls"][i]
          );

          let addonList = JSON.parse(JSON.stringify(control.value.addonList));
          let addonControl = <FormControl>control.get("addonList");

          addonList[addonInd].showPrice = addonValue.pet_extra_price;
          addonControl.setValue(addonList);
        }
      }
    } else {
      const addons = this.petDetails.controls["pets"].value.flatMap(
        (item) => item.addons
      );
      const addonsIds = addons.map((addon) => {
        return addon.id;
      });

      const existInArray = this.checkAddonList.map((addon) =>
        addonsIds.includes(addon)
      );

      for (let i = 0; i < existInArray.length; i++) {
        if (!existInArray[i]) {
          for (
            let i = 0;
            i < this.petDetails.controls["pets"].value.length;
            i++
          ) {
            const control = <FormGroup>(
              this.petDetails.controls["pets"]["controls"][i]
            );

            let addonList = JSON.parse(JSON.stringify(control.value.addonList));
            let addonControl = <FormControl>control.get("addonList");

            addonList[addonInd].showPrice = addonValue.price;
            addonList[addonInd].addonCheckoutPrice = 0;
            addonControl.setValue(addonList);
            this.checkAddonList = this.checkAddonList.filter(
              (id) => id !== addonId
            );
          }
          break;
        } else {
          if (this.isPetAvailable) {
            const control = <FormGroup>(
              this.petDetails.controls["pets"]["controls"][pet_i]
            );
            let addonList = JSON.parse(JSON.stringify(control.value.addonList));
            let addonControl = <FormControl>control.get("addonList");
            addonList[addonInd].showPrice = addonValue.pet_extra_price;
            addonControl.setValue(addonList);
          }
        }
      }
    }
  }
  checkaddonIsExists(addons, addonId) {
    if (addons && addons.length) {
      var isAddonIdPresent = addons.some(function (addon) {
        return addon.id === addonId;
      });

      if (isAddonIdPresent) {
        return true;
      } else {
        return false;
      }
    }
  }
  getDatesInRange() {
    const start = new Date(new Date(this.inwardDate));
    const end = new Date(new Date(this.outwardDate));
    const date = new Date(start.getTime());
    this.formatDates = [];
    while (date < end) {
      this.formatDates.push({
        date: moment(date).format("YYYY-MM-DD"),
        isChecked: true,
      });
      date.setDate(date.getDate() + 1);
    }
  }
  selectDate(event, date) {
    const control = <FormArray>this.petDetails.controls["pets"];
    if (control.controls.length > 0) {
      for (const index in control.controls) {
        if (control.controls.hasOwnProperty(index)) {
          if (control.controls[index].value.id == this.selectedPetId) {
            for (const addon of control.controls[index].value["addons"]) {
              if (addon.id == this.selectedAddonDetail.id) {
                this.previousSelectedDates = JSON.parse(
                  JSON.stringify(addon["selected_dates"])
                );

                if (
                  addon["selected_dates"] &&
                  !addon["selected_dates"].includes(date.date)
                ) {
                  addon["selected_dates"].push(date.date);
                  this.tempSelectedDate.push(date.date);
                  date.isChecked = true;
                } else {
                  addon["selected_dates"].splice(
                    addon["selected_dates"].indexOf(date.date),
                    1
                  );
                  date.isChecked = false;
                }
                this.totalDays = addon["selected_dates"].length;
              } else {
                let control = <FormControl>(
                  this.petDetails.controls["pets"]["controls"][
                    this.selectedPetIndex
                  ]["controls"]["addons"]
                );
                const isAddonIncluded = control.value.some(
                  (item) => item.id === this.selectedAddonDetail.id
                );
                if (!isAddonIncluded) {
                  if (!event.target.checked) {
                    this.formatDates.map((elem) => {
                      if (elem.date == date.date) {
                        elem.isChecked = false;
                      }
                    });
                    this.totalDays = this.formatDates.filter(
                      (date) => date.isChecked
                    ).length;
                  } else {
                    this.totalDays = 1;
                  }
                }
              }
            }

            if (!control.controls[index].value["addons"].length) {
              this.formatDates.map((elem) => {
                if (elem.date == date.date) {
                  if (!event.target.checked) {
                    elem.isChecked = false;
                  } else {
                    elem.isChecked = true;
                  }
                }
              });
              this.totalDays = this.formatDates.filter(
                (date) => date.isChecked
              ).length;
            }
          }
        }
      }
    }
  }
  onSubmit() {
    let control = <FormControl>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex][
        "controls"
      ]["addons"]
    );

    let addonObj = {
      id: this.selectedAddonDetail.id,
      selected_dates: [],
      selected_option: "",
      type: this.selectedAddonDetail.type,
    };

    let addons = JSON.parse(JSON.stringify(control.value));

    let hasCheckedTrue;

    if (this.selectedAddonDetail.options !== null) {
      hasCheckedTrue = this.selectedAddonDetail.options.some(
        (option) => option.isChecked
      );
    }
    const isAddonIncluded = addons.some(
      (item) => item.id === this.selectedAddonDetail.id
    );
    if (
      this.selectedAddonDetail.options &&
      this.selectedAddonDetail.options !== null &&
      !isAddonIncluded &&
      !hasCheckedTrue
    ) {
      addonObj["selected_option"] = this.selectedAddonDetail.options[0].value;
      addons.push(addonObj);
    }

    if (
      this.selectedAddonDetail.options &&
      this.selectedAddonDetail.options !== null &&
      !isAddonIncluded &&
      hasCheckedTrue
    ) {
      addonObj["selected_option"] = this.selectedOptionValue
        ? this.selectedOptionValue
        : this.selectedAddonDetail.options[0].value;
      addons.push(addonObj);
    }
    if (
      this.selectedAddonDetail.options == null &&
      this.selectedAddonDetail.type !== "all"
    ) {
      if (!isAddonIncluded) {
        addons.push(addonObj);
      }
    }
    control.setValue(addons);

    for (const key in control.value) {
      if (
        this.selectedAddonDetail &&
        this.selectedAddonDetail.options &&
        this.selectedAddonDetail.options.length
      ) {
        if (
          control.value[key].id == this.selectedAddonDetail.id &&
          control.value[key]["selected_option"] == ""
        ) {
          this.selectedAddonDetail.options.map((option) => {
            option.isChecked = false;
          });
          control.value[key]["selected_option"] =
            this.selectedAddonDetail.options[0].value;
          this.selectedAddonDetail.options[0].isChecked = true;
        } else if (
          control.value[key].id == this.selectedAddonDetail.id &&
          control.value[key]["selected_option"]
        ) {
          this.selectedAddonDetail.options.map((option) => {
            option.isChecked = false;
            if (option.value == control.value[key]["selected_option"]) {
              option.isChecked = true;
            }
          });
        }
      }

      // For Date selection
      if (this.formatDates && this.formatDates.length) {
        if (
          control.value[key].id == this.selectedAddonDetail.id &&
          !control.value[key]["selected_dates"].length
        ) {
          if (this.selectedAddonDetail.type == "custom") {
            this.formatDates.map((date) => {
              if (date.isChecked) {
                control.value[key]["selected_dates"].push(date.date);
                control.value[key]["type"] = this.selectedAddonDetail.type;
              }
            });
          }

          if (this.selectedAddonDetail.type == "single") {
            control.value[key]["selected_dates"] = [];
            control.value[key]["type"] = this.selectedAddonDetail.type;
          }

          if (this.selectedAddonDetail.type == "all") {
            this.formatDates.map((date) => {
              control.value[key]["selected_dates"].push(date.date);
              control.value[key]["type"] = this.selectedAddonDetail.type;
            });
          }
          this.totalDays = control.value[key]["selected_dates"].length;
        } else if (
          control.value[key].id == this.selectedAddonDetail.id &&
          control.value[key]["selected_dates"]
        ) {
          this.formatDates.map((date) => {
            date.isChecked = false;
            if (control.value[key]["selected_dates"].includes(date.date)) {
              date.isChecked = true;
            }
          });
          this.totalDays = control.value[key]["selected_dates"].length;
        }
      }
    }
    control.setValue(addons);
    this.addonPriceCalculation();
    this.checkAddonOption(
      this.selectedAddonDetail.id,
      this.selectedAddonDetail,
      this.selectedPetId,
      this.selectedAddonIndex,
      this.selectedPetIndex
    );
    this.selectedOptionValue = "";
    this.tempSelectedDate = [];
    this.modalService.dismissAll();
  }
  closeOptionModal() {
    let control = <FormControl>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex][
        "controls"
      ]["addons"]
    );

    const petControl = <FormGroup>(
      this.petDetails.controls["pets"]["controls"][this.selectedPetIndex]
    );
    let addonControl = <FormControl>petControl.get("addons");
    let addonArray = JSON.parse(JSON.stringify(petControl.value.addons));

    const isAddonIncluded = control.value.some(
      (item) => item.id === this.selectedAddonDetail.id
    );

    if (!isAddonIncluded && this.selectedAddonDetail.options !== null) {
      this.selectedAddonDetail.options.map((option) => {
        option.isChecked = false;
      });
      this.selectedAddonDetail.options[0].isChecked = true;
    }
    if (this.previousSelectedDates && this.previousSelectedDates.length) {
      this.previousSelectedDates = this.previousSelectedDates.filter(
        (date) => !this.tempSelectedDate.includes(date)
      );
    }

    if (isAddonIncluded && this.selectedAddonDetail.options !== null) {
      this.selectedAddonDetail.options.map((option) => {
        option.isChecked = false;
      });

      if (this.previousSelectedOptionValue == undefined) {
        this.selectedAddonDetail.options[0].isChecked = true;
      } else {
        this.selectedAddonDetail.options.map((option) => {
          if (option.value === this.previousSelectedOptionValue.value) {
            option.isChecked = true;
          }
        });

        for (let i = 0; i < addonArray.length; i++) {
          if (addonArray[i].id == this.selectedAddonDetail.id) {
            addonArray[i]["selected_option"] =
              this.previousSelectedOptionValue.value;
            addonArray[i]["selected_dates"] = this.previousSelectedDates;
          }
        }
      }
    } else {
      for (let i = 0; i < addonArray.length; i++) {
        if (addonArray[i].id == this.selectedAddonDetail.id) {
          addonArray[i]["selected_dates"] = this.previousSelectedDates;
        }
      }
    }
    addonControl.setValue(addonArray);
    this.tempSelectedDate = [];

    this.modalService.dismissAll();
  }
  addonPriceCalculation() {
    const pets = [];
    for (let index = 0; index < this.petDetails.value.pets.length; index++) {
      const pet = {
        id: this.petDetails.value.pets[index].id,
        name: this.petDetails.value.pets[index].name,
        pet_type_id: this.petTypeId,
        sub_pet_type_id: !this.petDetails.value.pets[index].sub_pet_type_id
          ? this.defaultSubPetId
          : this.petDetails.value.pets[index].sub_pet_type_id,
        addons:
          this.petDetails.value.pets[index].addons !== null
            ? this.petDetails.value.pets[index].addons
            : [],
      };
      pets.push(pet);
    }
    this.http
      .post(
        API_URLS.addonPriceCalculation,
        {
          cage_type_id: this.selectedCageTypeId,
          booking_from: this.checkinDate,
          booking_to: this.checkoutDate,
          pet_type_id: this.petTypeId,
          out_post_id: this.selectedOutpostId,
          pets: pets,
        },
        false
      )
      .subscribe((res) => {
        if (res.type === "success" && res.code === 200) {
          if (res.data) {
            for (let petId = 0; petId < res.data.pets.length; petId++) {
              for (
                let addonId = 0;
                addonId < res.data.pets[petId].addon.length;
                addonId++
              ) {
                const petControl = <FormGroup>(
                  this.petDetails.controls["pets"]["controls"][petId]
                );
                let addonListControl = <FormControl>petControl.get("addonList");
                let addonListArray = JSON.parse(
                  JSON.stringify(petControl.value.addonList)
                );

                for (const addon of addonListArray) {
                  if (addon.id == res.data.pets[petId].addon[addonId]["id"]) {
                    addon.addonCheckoutPrice =
                      res.data.pets[petId].addon[addonId]["total_price"];
                    addon.addonCheckoutActualPrice =
                      res.data.pets[petId].addon[addonId]["actual_total_price"];
                    addon.showPrice =
                      res.data.pets[petId].addon[addonId]["price"];
                  }
                }
                addonListControl.setValue(addonListArray);
              }
            }
          }
          this.isPetAvailable = true;
        } else {
          this.toasterService.error(res.message);
          this.isPetAvailable = false;
        }
      });
  }
  getClinicTiming() {
    this.http.post(API_URLS.clinicTiming, {}, false).subscribe((res: any) => {
      this.clinicTiming = res.data;

      //get days

      let inwardDate = new Date(this.inwardDate);
      let inwardDay = this.days[inwardDate.getDay()];

      let outwardDate = new Date(this.outwardDate);
      let outwardDay = this.days[outwardDate.getDay()];

      if (this.clinicTiming[inwardDay]) {
        // For inward Time

        this.inwardTime = this.clinicTiming[inwardDay].From;
        this.inwardHour = parseInt(this.inwardTime.split(":")[0], 10);
        this.inwardMinute = this.inwardTime.split(":")[1].split(" ")[0];
        const isInwardPM = this.inwardTime.includes("PM");

        if (isInwardPM && this.inwardHour !== 12) {
          this.inwardHour += 12;
        } else if (!isInwardPM && this.inwardHour === 12) {
          this.inwardHour = 0;
        }

        const inwardTime = new Date();
        inwardTime.setHours(this.inwardHour);
        inwardTime.setMinutes(0);

        this.inwardTime = inwardTime;

        // End

        // For outward time

        this.outwardTime = this.clinicTiming[outwardDay].To;
        this.outwardHour = parseInt(this.outwardTime.split(":")[0], 10);
        this.outwardMinute = this.outwardTime.split(":")[1].split(" ")[0];
        const isOutwardPM = this.outwardTime.includes("PM");

        if (isOutwardPM && this.outwardHour !== 12) {
          this.outwardHour += 12;
        } else if (!isOutwardPM && this.outwardHour === 12) {
          this.outwardHour = 0;
        }

        const outwardTime = new Date();
        outwardTime.setHours(this.outwardHour);
        outwardTime.setMinutes(0);

        this.outwardTime = outwardTime;

        // end
      }
    });
  }
  openVaccinationModal() {
    const modalRef = this.modalService.open(ModalVaccinationProductComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "vaccination-modal modal-bg-blue",
    });

    modalRef.componentInstance.apiParams = this.vacconationApiParams;
    modalRef.componentInstance.closeVaccinModal.subscribe(
      (response) => {
        if (
          response &&
          response.selectedProduct &&
          response.selectedProduct.length
        ) {
          this.petProductDetail = response.selectedProduct;
        } else if (localStorage.getItem("purchasedProduct")) {
          this.petProductDetail = JSON.parse(
            localStorage.getItem("purchasedProduct")
          );
        } else {
          this.petProductDetail = [];
        }
        this.formDataWithAPI();
      },
      (reason) => {}
    );
  }

  selectInwardDate() {
    if (this.inwardDate) {
      this.selectedDateArray = [];
      const inwardDate = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(
        inwardDate[1] + "/" + inwardDate[0] + "/" + inwardDate[2]
      );
      const expectedOutwardDate = this.addDays(this.inwardDate, 1);
      this.outwardDate = expectedOutwardDate;
      const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
      this.selectedDateArray.push(
        expectedOutward[1] + "/" + expectedOutward[0] + "/" + expectedOutward[2]
      );
      this.errorMessage = "";
      this.allowedNextStep = true;
      this.checkinDate = this.selectedDateArray[0];
      this.checkoutDate = this.selectedDateArray[1];
    }
  }

  selectOutwardDate() {
    const inwardDate = Utils.getDateFormat(this.inwardDate);
    const outwardDate = Utils.getDateFormat(this.outwardDate);
    const checkInDate =
      inwardDate[1] + "/" + inwardDate[0] + "/" + inwardDate[2];
    const checkoutDate =
      outwardDate[1] + "/" + outwardDate[0] + "/" + outwardDate[2];
    if (checkInDate == checkoutDate) {
      this.outwardDate = null;
      this.selectInwardDate();
      return false;
    } else {
      const checkInDiff = moment(checkInDate, MOMENT_FORMAT_START_DATE);
      const checkoutDiff = moment(checkoutDate, MOMENT_FORMAT_START_DATE);
      const totalDays = checkoutDiff.diff(checkInDiff, "days");
      this.selectedDateArray = [];
      const date = Utils.getDateFormat(this.inwardDate);
      this.selectedDateArray.push(date[0] + "/" + date[1] + "/" + date[2]);
      for (let i = 1; i <= totalDays; i++) {
        const expectedOutwardDate = this.addDays(this.inwardDate, i);
        const expectedOutward = Utils.getDateFormat(expectedOutwardDate);
        this.selectedDateArray.push(
          expectedOutward[0] +
            "/" +
            expectedOutward[1] +
            "/" +
            expectedOutward[2]
        );
      }
    }
    this.errorMessage = "";
    this.allowedNextStep = true;
    this.checkinDate = checkInDate;
    this.checkoutDate = checkoutDate;
  }

  getSelectedDays(date) {
    if (!this.outwardDate) {
      if (this.inwardDate) {
        const format = date.day + "/" + (date.month + 1) + "/" + date.year;
        return this.selectedDateArray.includes(format);
      }
    } else {
      const format = date.day + "/" + (date.month + 1) + "/" + date.year;
      return this.selectedDateArray.includes(format);
    }
  }

  addDays(date, count) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + count);
    return newDate;
  }
  showDescription(title, description) {
    this.apiParams = {
      title: title,
      description: description,
    };
    const modalRef = this.modalService.open(DisplayDescriptionComponent, {
      size: "xl",
      centered: true,
      backdrop: "static",
      keyboard: false,
    });

    modalRef.componentInstance.fromParent = { data: this.apiParams };
  }
  closeModal() {
    Utils.enableBodyScroll();
  }
  decodeString(encoded: string): string {
    let decoded = encoded;
    let previous = null;

    while (decoded !== previous) {
      previous = decoded;
      decoded = decodeURIComponent(decoded);
    }
    return decoded;
  }
}
